var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("report-section", {
    attrs: {
      "report-type": _vm.$options.ReportTypes.ShipmentTracking,
      "report-title": _vm.$t("general.menu.reports.shipmentTracking")
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }